var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var _a;
import React, { useState } from 'react';
import styled from 'styled-components';
import { ICON_SIZES, Icon } from "../Icon";
import { View, VIEW_ALIGN, INDENT, SPACE_FILL } from "../View";
import { STACK_DIRECTION, STACK_DISTRIBUTION, STACK_GAP, StackView, STACK_ALIGN } from "../StackView";
import { Text } from "../Text";
import { ACTION_VIEW, Dialog, DIALOG_SIZE } from "../Dialog";
import { createUIElement } from "../helpers";
import { LargeInfoStatusIcon, RedCloseIcon, LargeWarningStatusIcon } from "../icons";
var StyledText = styled(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    word-break: keep-all; /* for support IE */\n    word-break: break-word; /* for support Chrome */\n    overflow: hidden;\n"], ["\n    word-break: keep-all; /* for support IE */\n    word-break: break-word; /* for support Chrome */\n    overflow: hidden;\n"])));
export var MESSAGE_BOX_ICON_VIEW;
(function (MESSAGE_BOX_ICON_VIEW) {
    MESSAGE_BOX_ICON_VIEW["info"] = "info";
    MESSAGE_BOX_ICON_VIEW["error"] = "error";
    MESSAGE_BOX_ICON_VIEW["warning"] = "warning";
})(MESSAGE_BOX_ICON_VIEW || (MESSAGE_BOX_ICON_VIEW = {}));
var ICONS = (_a = {},
    _a[MESSAGE_BOX_ICON_VIEW.error] = React.createElement(RedCloseIcon, null),
    _a[MESSAGE_BOX_ICON_VIEW.info] = React.createElement(LargeInfoStatusIcon, null),
    _a[MESSAGE_BOX_ICON_VIEW.warning] = React.createElement(LargeWarningStatusIcon, null),
    _a);
export var MessageBox = createUIElement('MessageBox', function (_a, ref) {
    var className = _a.className, header = _a.header, onRequestClose = _a.onRequestClose, children = _a.children, _b = _a.iconView, iconView = _b === void 0 ? MESSAGE_BOX_ICON_VIEW.info : _b, iconSrc = _a.iconSrc, actions = _a.actions, detailContent = _a.detailContent, isDetailContentShown = _a.isDetailContentShown, _c = _a.detailButtonText, detailButtonText = _c === void 0 ? { show: 'Show detail', hide: 'Hide detail' } : _c, pending = _a.pending, loading = _a.loading, canClose = _a.canClose, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "header", "onRequestClose", "children", "iconView", "iconSrc", "actions", "detailContent", "isDetailContentShown", "detailButtonText", "pending", "loading", "canClose", "onKeyPress", "style"]);
    var _d = useState(!!isDetailContentShown), isDetailContentShownState = _d[0], setDetailContentShownState = _d[1];
    return (React.createElement(Dialog, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'dialog-wrapper', className: "vm-MessageBox " + className, size: {
            width: DIALOG_SIZE.s,
            height: DIALOG_SIZE.auto
        }, canClose: canClose, pending: !!pending, loading: !!loading, onRequestClose: onRequestClose, header: header, actions: actions || [{ text: 'Ok', onClick: onRequestClose }], secondaryActions: detailContent
            ? [
                {
                    text: isDetailContentShownState
                        ? detailButtonText.hide
                        : detailButtonText.show,
                    view: ACTION_VIEW.text,
                    onClick: function () {
                        setDetailContentShownState(function (state) { return !state; });
                    }
                }
            ]
            : [], onKeyPress: onKeyPress, ref: ref, style: style }),
        React.createElement(StackView, { direction: STACK_DIRECTION.column, indentBottom: INDENT.s, gap: STACK_GAP.l },
            React.createElement(StackView, { direction: STACK_DIRECTION.row, gap: STACK_GAP.m, align: STACK_ALIGN.start, distribution: STACK_DISTRIBUTION.lastFill },
                React.createElement(Icon, { size: ICON_SIZES.xl, src: iconSrc || ICONS[iconView] }),
                React.createElement(View, { align: VIEW_ALIGN.center, spaceFill: SPACE_FILL.all },
                    React.createElement(StyledText, null, children))),
            isDetailContentShownState ? detailContent : null)));
});
var templateObject_1;
//# sourceMappingURL=MessageBox.js.map